import BaseClass from "../BaseClass";

export default class SubmitOnChange extends BaseClass {
    constructor(element) {
        super(element);

        this.$element.on('change', $.proxy(this.onChange, this));
    }

    onChange() {
        const $form = $(this.element.form);

        let submitter = undefined;

        const submitterSelector = this.$element.data('submitter-selector');
        if (submitterSelector != undefined) {
            const $submitter = $(submitterSelector);

            if ($submitter.length) {
                submitter = $submitter.get(0);
            }
        }

        const event = new SubmitEvent('submit', {submitter});

        $form.trigger($.Event(event));
    }

    destroyListener() {
        this.$element.off('change', $.proxy(this.onChange, this));
    }
}